function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "rqdi5xvdda",
  width: "165.7%",
  height: "197.9%",
  x: "-32.9%",
  y: "-48.9%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", {
  filter: "url(#rqdi5xvdda)",
  transform: "translate(-90 -639) translate(90 635)"
}, React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(27 42)"
}, React.createElement("rect", {
  width: 67,
  height: 28,
  x: .36,
  y: .12,
  fill: "#26B489",
  rx: 4.8
}), React.createElement("path", {
  fill: "#FFF",
  d: "M15.431 20.16v-5.273h5.392v-1.35H15.43V9.352h5.873V7.985h-7.391V20.16h1.518zm9.476 0V7.453h-1.451V20.16h1.451zm6.312.16c2.59 0 4.194-1.788 4.194-4.708 0-2.928-1.603-4.708-4.194-4.708-2.59 0-4.193 1.78-4.193 4.708 0 2.92 1.603 4.708 4.193 4.708zm0-1.308c-1.721 0-2.691-1.248-2.691-3.4 0-2.16.97-3.4 2.691-3.4 1.722 0 2.692 1.24 2.692 3.4 0 2.152-.97 3.4-2.692 3.4zm6.667 4.439c1.611 0 2.337-.625 3.113-2.734l3.552-9.653h-1.544l-2.489 7.484h-.135l-2.497-7.484h-1.57l3.367 9.104-.169.54c-.38 1.097-.835 1.494-1.67 1.494-.203 0-.43-.009-.608-.042v1.24c.202.034.456.05.65.05zm11.391-3.13c1.257 0 2.337-.6 2.91-1.612h.136v1.451h1.384V7.453h-1.452V12.5h-.126c-.515-.996-1.586-1.595-2.852-1.595-2.312 0-3.822 1.856-3.822 4.708 0 2.86 1.493 4.708 3.822 4.708zm.338-1.309c-1.663 0-2.658-1.274-2.658-3.4 0-2.118 1.004-3.4 2.658-3.4 1.645 0 2.674 1.316 2.674 3.4 0 2.101-1.02 3.4-2.674 3.4z"
})), React.createElement("path", {
  fill: "#26B489",
  d: "M112.676 13.552l12.76 25.52c.711 1.423.135 3.153-1.288 3.864-.81.405-1.765.405-2.576 0L110.1 37.2l-11.472 5.736c-1.423.711-3.153.135-3.864-1.288-.405-.81-.405-1.765 0-2.576l12.76-25.52c.711-1.423 2.441-2 3.864-1.288.557.279 1.01.73 1.288 1.288z",
  transform: "scale(-1 1) rotate(-45 0 293.405)"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 140,
    height: 90,
    viewBox: "0 0 140 90"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/floyd-cursor.37d46e04.svg";
export { SvgComponent as ReactComponent };